export default __webpack_public_path__ + "static/project-bridge-8c40d57b11ddb13436fe7bbbee2ecda1.png";